import { render, staticRenderFns } from "./OpenSiteIncidentsWidget.vue?vue&type=template&id=c51d05c2&scoped=true&"
import script from "./OpenSiteIncidentsWidget.vue?vue&type=script&lang=js&"
export * from "./OpenSiteIncidentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./OpenSiteIncidentsWidget.vue?vue&type=style&index=0&id=c51d05c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51d05c2",
  null
  
)

export default component.exports